<div class="app-container" *ngIf="accountService.isUserLoggedIn() === true">
<div class="loading-container" *ngIf="isLoading">
  <div class="lds-grid">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
<div class="portal-header">
    <h5 class="header-text">Proplab Files for RefNo: {{folderName}}</h5>
  </div>
<br/>
<div class="content">
<table mat-table [dataSource]="files" class="table-striped">
  <ng-container matColumnDef="fileName">
    <th mat-header-cell *matHeaderCellDef>File Name</th>
    <td mat-cell *matCellDef="let files"><a href="javascript:void(0)" (click)="displayOrDownloadFile(files.fileName,files.blobPath, true)">{{files.fileName}}</a></td>
  </ng-container>

  <ng-container matColumnDef="view">
    <th mat-header-cell *matHeaderCellDef>View</th>
    <td mat-cell *matCellDef="let files"><button (click)="displayOrDownloadFile(files.fileName,files.blobPath, true)"
        class="btn btn-sm mat-raised-button btn-danger">View</button></td>
  </ng-container>

  <ng-container matColumnDef="download">
    <th mat-header-cell *matHeaderCellDef>Download</th>
    <td mat-cell *matCellDef="let files"><button (click)="displayOrDownloadFile(files.fileName,files.blobPath, false)"
        class="btn btn-sm mat-raised-button btn-danger">Download</button></td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="9999">
      <div>
        <b>No files available</b>
      </div>
    </td>
  </tr>
</table>
</div>
</div>
